
export const errors = {
  generic: 'An unexpected error occurred.',
  network: 'Connection lost. Please check your internet.',
  insufficientFunds: {
    title: 'Insufficient Funds',
    message: 'Not enough credits in Wallet for this transaction.',
    suggestion: 'Please top up to continue.'
  },
  quotaExceeded: {
    title: 'Quota Exceeded',
    message: 'You have reached the usage limit for this billing cycle.',
    suggestion: 'Please upgrade your plan to increase limits.'
  },
  duplicateEntry: {
    title: 'Duplicate Entry',
    message: 'This data (e.g., phone, ID) already exists in the system.',
    suggestion: 'Check if this record was already registered.'
  },
  notFound: {
    title: 'Not Found',
    message: 'The requested data does not exist or has been deleted.',
    suggestion: 'Try searching with different keywords.'
  },
  permissionDenied: {
    title: 'Access Denied',
    message: 'You do not have permission to access this resource.',
    suggestion: 'Contact your administrator if you believe this is an error.'
  },
  auth: {
    invalidLogin: 'Incorrect password.',
    userNotFound: 'User account not found.',
    sessionExpired: 'Session expired. Please log in again.'
  }
};
